import React from 'react';

export default function InformationIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			aria-hidden="true"
			focusable="false"
		>
			<g fillRule="evenodd">
				<path d="M11.58 7.829h-.477l-2.714.437-.1.318c.106-.006.203-.01.289-.01.172 0 .31.047.413.14a.419.419 0 0 1 .154.317c0 .186-.054.46-.16.825l-1.113 3.828a2.7 2.7 0 0 0-.139.755.98.98 0 0 0 .308.741c.205.195.48.293.825.293.908 0 1.766-.702 2.575-2.107l-.278-.16c-.332.517-.62.875-.865 1.074a.393.393 0 0 1-.268.119c-.053 0-.102-.027-.15-.08a.242.242 0 0 1-.069-.159c0-.106.043-.321.13-.647L11.58 7.83zm-.497-3.689c-.325 0-.6.117-.825.349-.225.231-.338.51-.338.835 0 .325.115.602.344.83.229.229.502.343.82.343.325 0 .602-.114.835-.343a1.13 1.13 0 0 0 .348-.83c0-.325-.115-.603-.344-.835a1.135 1.135 0 0 0-.84-.348z" />
				<path
					d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18.986a8.986 8.986 0 1 1 0-17.972 8.986 8.986 0 0 1 0 17.972z"
					fillRule="nonzero"
				/>
			</g>
		</svg>
	);
}
